// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { xIsAuthenticated } from "@werner/App/Store/Selectors/GeneralSelectors";
import { getSettingsCollection } from "@werner/App/Store/Selectors/SettingsSelectors";
import React from "react";
import { connect } from "react-redux";

const enum fields {
    width = "width",
    height = "height",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.width]: string;
        [fields.height]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    rockwelliFrameUrl: getSettingsCollection(state).rockwellConfiguratorSettings.iFrameUrl,
    isAuthenticated: xIsAuthenticated(state),
    enableRockwellConfigurator: getSettingsCollection(state).rockwellConfiguratorSettings.enableRockwellConfigurator,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const RockwellConfigurator: React.FC<Props> = ({
    rockwelliFrameUrl,
    isAuthenticated,
    fields,
    enableRockwellConfigurator,
}) => {
    if (!isAuthenticated || !enableRockwellConfigurator) {
        return null;
    }
    return <iframe width={fields.width} height={fields.height} src={rockwelliFrameUrl} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RockwellConfigurator),
    definition: {
        group: "Xngage Custom" as any,
        displayName: "Rockwell Configurator",
        fieldDefinitions: [
            {
                name: fields.width,
                displayName: "width",
                editorTemplate: "TextField",
                defaultValue: "100%",
                fieldType: "General",
            },
            {
                name: fields.height,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "800px",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
